export const UPLOAD_FILE_TYPES = {
  AVATAR: 'Avatar',
} as const

export type UploadFileType =
  (typeof UPLOAD_FILE_TYPES)[keyof typeof UPLOAD_FILE_TYPES]

export type UploadFileRequest = {
  file: File
  type: UploadFileType
}

export type UploadFileResponse = {
  fileName: string
}
